import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FeedbackRequestBody } from './feedback.model';

@Injectable({
  providedIn: 'root',
})
export class FeedbackHttpService {
  constructor(private http: HttpClient) {}

  postFeedback(url: string, feedbackRequestBody: FeedbackRequestBody) {
    return this.http.post(url, feedbackRequestBody);
  }
}
